import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import ProjectDetailLoadingShell from './components/sections/ProjectDetailLoadingShell';
import { Layout, ScrollToTop } from './components/layout';
import ErrorBoundary from './components/ErrorBoundary';
import { ThemeProvider } from './contexts/themeContext';
import { SITE_LAUNCH_MODE } from './constants';
import { GoogleMapsLoaderProvider } from './components/ui/GoogleMapsLoaderProvider';

const LaunchPage = lazy(() => import('./pages/LaunchPage'));
const ProjectDetailPage = lazy(() => import('./pages/ProjectDetailPage'));
const FullSiteRoutes = lazy(() => import('./FullSiteRoutes'));

const RouteFallback = () => {
  const { pathname } = useLocation();
  if (/^\/projet\//.test(pathname)) {
    return <ProjectDetailLoadingShell />;
  }
  return <div className="min-h-screen bg-white" aria-hidden />;
};

const mapsEnabled = Boolean(process.env.REACT_APP_GOOGLE_MAPS_API_KEY);

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <GoogleMapsLoaderProvider enabled={mapsEnabled}>
          <Router>
            <ScrollToTop />
            <Layout>
              <Suspense fallback={<RouteFallback />}>
                {SITE_LAUNCH_MODE ? (
                  <Routes>
                    <Route path="/" element={<LaunchPage />} />
                    <Route path="/projet/:id" element={<ProjectDetailPage />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                ) : (
                  <FullSiteRoutes />
                )}
              </Suspense>
            </Layout>
          </Router>
        </GoogleMapsLoaderProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
